var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvening(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.221,
    height: 19.441,
    viewBox: "0 0 23.221 19.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.424 15.047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.028,373.446h-18.9a.736.736,0,0,0,0,1.473h18.9a.736.736,0,0,0,0-1.473Z",
    transform: "translate(-31.391 -373.446)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.315 17.968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.14,437.852h-7.118a.736.736,0,1,0,0,1.473h7.118a.736.736,0,1,0,0-1.473Z",
    transform: "translate(-161.285 -437.852)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.94 6.136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.647,176.976a5.666,5.666,0,0,0-3.389,10.21.736.736,0,0,0,.888-1.176,4.2,4.2,0,1,1,5.011-.006.736.736,0,0,0,.872,1.187,5.666,5.666,0,0,0-3.381-10.216Z",
    transform: "translate(-130.977 -176.976)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.874 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.5,41.674a.736.736,0,0,0-.736.736v3.927a.736.736,0,1,0,1.473,0V42.41A.736.736,0,0,0,240.5,41.674Z",
    transform: "translate(-239.763 -41.674)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.821 10.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.594,281.438h-3.927a.736.736,0,0,0,0,1.473h3.927a.736.736,0,0,0,0-1.473Z",
    transform: "translate(-392.93 -281.438)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.664,281.438H.736a.736.736,0,1,0,0,1.473H4.664a.736.736,0,1,0,0-1.473Z",
    transform: "translate(0 -281.438)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.808 3.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.58,111.71a.736.736,0,0,0-1.041,0l-2.774,2.774a.736.736,0,0,0,1.041,1.041l2.774-2.774A.736.736,0,0,0,352.58,111.71Z",
    transform: "translate(-348.549 -111.495)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.166 3.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.848,114.482l-2.774-2.774a.736.736,0,1,0-1.041,1.041l2.774,2.774a.736.736,0,0,0,1.041-1.041Z",
    transform: "translate(-69.818 -111.493)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvening);
export default __webpack_public_path__ + "static/media/evening.c2101b1971fd743f42c5ce0246cc551a.svg";
export { ForwardRef as ReactComponent };